import React from "react";
import { UserOutlined, ArrowUpOutlined, BankOutlined } from "@ant-design/icons";
import GamePicker from "./GamePicker";

export const soloGames = [
    {
        to: "/higherOrLower",
        labelKey: "games.names.higherOrLower",
        icon: <ArrowUpOutlined />,
    },
    {
        to: "/greekTempel",
        labelKey: "games.names.greekTemple",
        icon: <BankOutlined />,
    },
];

const SaufAlone: React.FC = () => (
    <GamePicker games={soloGames} titleKey="pages.saufAlone.title" icon={<UserOutlined />} maxWidth={460} columns={{ sm: 12 }} bordered={false} playerCountKey="pages.drinkhelper.players.single" />
);

export default SaufAlone;
